var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[_c('a',{staticClass:"left-button pfm",attrs:{"href":"https://work.weixin.qq.com/kfid/kfcd2abf8edab2d31cd"}},[_vm._v("咨询客服")]),_c('a',{staticClass:"right-button pfm",attrs:{"href":"http://www.89mc.com/banzuhui/download.html"}},[_vm._v("下载班组云APP")])])
}]

export { render, staticRenderFns }